import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Badge} from "primereact/badge";
import {Dropdown} from "primereact/dropdown";
import moment from "moment";
import axios from "axios";

const ProductionitemSubcontractorListComponent = (props) => {

  const {t} = props;
  const [productionitemSubcontractors, setProductionitemSubcontractors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      window.App.setState({rerenderProductionitemSubcontractorList: false})
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/api/v2/production-item/subcontractor-list" + "/" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setProductionitemSubcontractors(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                tooltip="Módosítás" tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  window.App.setState({
                    sidebarProductionitemSubcontractorUpdate: true,
                    productionitemSubcontractorFormMethod: 'update',
                    productionitemSubcontractorRowData: rowData
                  })
                }}/>
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip="Megtekintés" tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  window.App.setState({
                    sidebarProductionitemSubcontractorShow: true,
                    propsProductionitemSubcontrator: rowData,
                  })
                }}/>
      </React.Fragment>
    );
  }

  const [statuses, setStatuses] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');
  const status = (rowData) => {
    if (statuses && statuses[0]) {
      let status = statuses.filter(item => item.id === rowData.status)
      if (status[0] && status[0].name) {
        return status[0].name
      }
    }
  }

  const isTodayOrTomorrow = (deadline) => {
    const today = moment().startOf('day');
    const tomorrow = moment().add(1, 'day').startOf('day');
    const date = moment.utc(deadline).local().startOf('day');
    return date.isSame(today, 'day') || date.isSame(tomorrow, 'day');
  };
  const isPastDate = (deadline) => {
    const today = moment().startOf('day');
    const date = moment.utc(deadline).local().startOf('day');
    return date.isBefore(today, 'day');
  };


  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/production_status",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setStatuses(response.data)
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderProductionitemSubcontractorList === true])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage="Nincs találat."
                 value={productionitemSubcontractors} paginator first={lazyParams.first} totalRecords={totalRecords}
                 onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 dataKey="id"
                 ref={dt}
      >
        <Column field="project_number" header={t('projectNumber')} sortable filter></Column>
        <Column field="project_item_name" header={t('project') + " tétel"} sortable filter></Column>
        <Column field="external_reference" header={t('externalReference')} sortable filter></Column>
        <Column field="technology_name" header={"Technológia"} sortable filter></Column>
        <Column field="partner_name" header={t('partnerName')} sortable filter></Column>
        <Column field="subcontractor_name" header={"Alvállalkozó"} sortable filter></Column>
        <Column field="status" header={"Státusz"} sortable filter
                body={(rowData) => {
                  return(
                    <>
                      {status(rowData)}
                    </>
                  )
                }}
                filterElement={() => {
                  return (
                    <>
                      <Dropdown options={statuses}
                                id={"projectStatuses"}
                                optionValue={"id"}
                                optionLabel={"name"}
                                showClear
                                emptyMessage={"Még nincs státusz..."}
                                onChange={(e) => {
                                  setSelectedStatus(e.value)
                                  dt.current.filter(e.value, 'status', '');
                                }}
                                style={{width: '120px'}}
                                value={selectedStatus}
                      />
                    </>
                  )
                }}
        ></Column>
        <Column field="deadline" header={t('deadline')}  className={"p-text-nowrap"}  sortable body={(rowData) => {
          const isTodayOrTomorrowDate = isTodayOrTomorrow(rowData.deadline);
          const isPast = isPastDate(rowData.deadline);
          if (rowData.deadline && rowData.deadline !== null) {
            return (
              <>
                {(rowData.status !== 'done' || rowData.status !== 'deleted') &&
                <>
                  {isTodayOrTomorrowDate ? (
                    <Badge value={moment.utc(rowData.deadline).local().format('YYYY-MM-DD')} severity="warning"></Badge>
                  ):(
                    <>
                      {isPast ? (
                        <Badge value={moment.utc(rowData.deadline).local().format('YYYY-MM-DD')} severity="danger"></Badge>
                      ):(
                        <Badge value={moment.utc(rowData.deadline).local().format('YYYY-MM-DD')} severity="info"></Badge>
                      )}
                    </>
                  )}
                </>
                }
                {(rowData.status === 'deleted') &&
                <span className={"p-text-strikethrough"}>
                  {moment.utc(rowData.deadline).local().format('YYYY-MM-DD')}
                </span>
                }
                {(rowData.status === 'done') &&
                  <>
                    <Badge value={moment.utc(rowData.deadline).local().format('YYYY-MM-DD')} severity="success"></Badge>
                  </>
                }
              </>
            )
          }
        }}></Column>
        <Column field="created_at" header={"Létrehozva"}  className={"p-text-nowrap"}  sortable body={(rowData) => {
          if (rowData.created_at && rowData.created_at !== null) {
            return (
              <>{moment.utc(rowData.created_at).local().format('YYYY-MM-DD HH:mm:ss')}</>
            )
          }
        }}></Column>
        <Column field="updated_at" header={"Módosítva"}  className={"p-text-nowrap"}  sortable body={(rowData) => {
          if (rowData.updated_at && rowData.updated_at !== null) {
            return (
              <>{moment.utc(rowData.updated_at).local().format('YYYY-MM-DD HH:mm:ss')}</>
            )
          }
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>

    </>
  )
}
export default withTranslation('common')(ProductionitemSubcontractorListComponent);
